import React from 'react';
import { Elements } from 'react-stripe-elements';
import StripeCardsSection from './StripeCardsSection';


class StripeStoreCheckout extends React.Component {
  render() {
    console.log('MyStoreCheckout render')
    console.log(this.props)
    return (
      <div className="Checkout">
        <Elements>
          <StripeCardsSection isPay={this.props.isPay} gotToken={this.props.gotToken}/>
        </Elements>
      </div>
    );
  }
}

export default StripeStoreCheckout;



// WEBPACK FOOTER //
// ./src/components/Stripe/StripeStoreCheckout.js